import { useState } from 'react';
import { ApiError } from 'requests/RequestBase';
import { GetOrderResData, callDeleteSavedCardApi } from 'requests/RequestPayment';
import { HttpStatus } from 'consts/HttpStatus';
import { ReactError } from 'consts/ReactError';

// 共通決済画面の複数カード情報を管理するhook
export const usePaymentCards = (
	Page: any,
	setPage: React.Dispatch<React.SetStateAction<number>>,
	setError: React.Dispatch<React.SetStateAction<string>>,
	order: GetOrderResData,
) => {
	// 保存済みクレジットカード選択値
	const NEW_CARD_SELECT_VALUE = 9999;
	const [selectedCard, setSelectedCard] = useState(0);
	const handleChangeSavedCardSelectValue = async (event: React.ChangeEvent<HTMLInputElement>) => {
		setSelectedCard(Number(event.target.value));
	};
	const isCardSelected = (i: number) => {
		return i === selectedCard;
	};

	const [deleteCardIndex, setDeleteCardIndex] = useState(0);
	const selectDeleteCard = (index: number) => {
		setDeleteCardIndex(index);
		setPage(Page.DELETE_CARD);
	};
	const [deleteCardLoading, setDeleteCardLoading] = useState(false);
	const deleteCard = async () => {
		setDeleteCardLoading(true);
		const result = await callDeleteSavedCardApi(order.payment_tokens[deleteCardIndex].payment_id);
		if (result.status === HttpStatus.GATEWAY_TIMEOUT) {
			setError(ReactError.E0009);
			setDeleteCardLoading(false);
			return;
		}
		if (result.status !== HttpStatus.OK) {
			const errorData = result.data as ApiError;
			setError(errorData.message);
			setDeleteCardLoading(false);
			return;
		}
		setDeleteCardLoading(false);
		order.payment_tokens.splice(deleteCardIndex, 1);
		setSelectedCard(0);
		setPage(Page.DEFAULT);
	};

	return {
		NEW_CARD_SELECT_VALUE,
		handleChangeSavedCardSelectValue,
		selectedCard,
		isCardSelected,
		selectDeleteCard,
		deleteCardLoading,
		deleteCard,
		deleteCardIndex,
	};
};
